import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import "./splash.css";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    backgroundColor: "white",
  },
  playIcon: {
    marginTop: "10vh",
    height: "25vh",
    margin: "auto",
  },
}));

export default function SplashSonvi() {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/mainMap");
    }, 3000);
  }, [navigate]);
  const classes = useStyles();

  const handleClick = () => navigate("/mainMap");

  return (
    <React.Fragment>
      <div onClick={handleClick} className={classes.root}>
        <img
          className={classes.playIcon}
          src="/SonviLogo.png"
          alt="sonvi_splash"
        />
      </div>
    </React.Fragment>
  );
}
